if (!customElements.get('product-form')) {
    customElements.define('product-form', class ProductForm extends HTMLElement {
        constructor() {
            super();

            this.form = this.querySelector('form');
            this.form.querySelector("[name='id[]']").disabled = false;
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
            this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            this.submitButton = this.querySelector('[type="submit"]');

            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

            this.hideErrors = this.dataset.hideErrors === 'true';
        }

        

        async addonsAddtoCart(item){
            const formData = new FormData();
            try {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                const addonsEls = document.querySelectorAll(`.jci-addons input[data-addons-input]:checked`);
                let i = 1;
                const config = fetchConfig('javascript');
                config.headers['X-Requested-With'] = 'XMLHttpRequest';
                delete config.headers['Content-Type'];
                addonsEls.forEach((addonsEl) => {
                    formData.append(`items[${i}][id]`, addonsEl.value);
                    formData.append(`items[${i}][quantity]`, 1);
                    formData.append(`items[${i}][properties][_jci_addon]`, "true");
                    formData.append(`items[${i}][properties][Addon]`, String(item.title));
                    formData.append(`items[${i}][properties][_qualified_by]`, String(item.id));
                    i++;
                });
                config.body = formData;
                let data = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
                return data;
            } catch (error) {
                throw new Error(error.message);
                
            }
        }

        onSubmitHandler(evt) {
            evt.preventDefault();
            const quickViewModal = document.querySelector('quick-view-modal');
            const findQuickViewEl = (el) => {
                return (quickViewModal.querySelector((el)) ? quickViewModal.querySelector((el)) : undefined);
            }
            const isQuickViewActive = (quickViewModal && quickViewModal.classList.contains('show'));
            const loader = isQuickViewActive ? findQuickViewEl('.js-quickview-loader') : document.querySelector('.js-product-loader');
            if (loader) window.Global.showLoader(loader);
            if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

            this.handleErrorMessage();

            this.submitButton.setAttribute('aria-disabled', true);

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            delete config.headers['Content-Type'];

            const formData = new FormData(this.form);
            if (this.cart) {
                formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                this.cart.setActiveElement(document.activeElement);
            }

            config.body = formData;

            fetch(`${routes.cart_add_url}`, config)
                .then((response) => response.json())
                .then(async (response) => {
                    let addonCart = response;
                    try {
                        const addonsEls = document.querySelectorAll(`.jci-addons input[data-addons-input]:checked`);
                        if(addonsEls.length>0){
                            addonCart = await this.addonsAddtoCart(response);
                        }
                    } catch (error) { 
                        addonCart = response;
                        console.log('addonCart error: ', error)
                    }

                    if (response.status) {
                        publish(PUB_SUB_EVENTS.cartError, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            errors: response.errors || response.description,
                            message: response.message,
                        });
                        this.handleErrorMessage(response.description);

                        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                        if (!soldOutMessage) return;
                        this.submitButton.setAttribute('aria-disabled', true);
                        this.submitButton.querySelector('span').classList.add('hidden');
                        soldOutMessage.classList.remove('hidden');
                        this.error = true;
                        return;
                    } else if (!this.cart) {
                        window.location = window.routes.cart_url;
                        return;
                    }

                    const modalEl = window.bootstrap5.Modal.getInstance('quick-view-modal')
                    if (modalEl) modalEl.hide()

                    const modalBasket = document.querySelector('cart-drawer');
                    if (modalBasket) {
                        modalBasket.classList.remove('translate-x-full');
                        document.getElementById('CartDrawer-Overlay').classList.remove('opacity-0', 'invisible');
                    }

                    if (!this.error)
                        publish(PUB_SUB_EVENTS.cartUpdate, {
                            source: 'product-form',
                            productVariantId: formData.get('id'),
                            cartData: response
                        });
                    this.error = false;
                        console.log('addonCart', addonCart);
                    this.cart.renderContents(addonCart);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => {
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    if (loader) window.Global.hideLoader(loader);
                });
        }

        handleErrorMessage(errorMessage = false) {
            if (this.hideErrors) return;

            this.errorMessageWrapper =
                this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper') || document.querySelector('.product-form__error-message-wrapper');
            if (!this.errorMessageWrapper) return;
            this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message') || document.errorMessageWrapper.querySelector('.product-form__error-message');

            if (errorMessage && !errorMessage.email) {
                this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
                this.errorMessage.textContent = errorMessage;
            }
        }
    });
}
